module.exports = __webpack_public_path__ + "img/national-association-of-colored-women.366deadd.png";